import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserInfoResolver } from '@shared/resolvers/user-info.resolver';

@Injectable({
  providedIn: 'root',
})
export class RoleGuardService {
  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const groups = this.resolver.resolve().groups;
    const expectedGroup = route.data.expectedGroup;

    return groups.some(group => group.value === expectedGroup);
  }

  constructor(private resolver: UserInfoResolver) {}
}
